const DEFAULT_API =
  process.env.NODE_ENV === 'production'
    ? 'https://api-loa.irfanthomi.com/'
    : 'http://localhost:3002/';

export function resolveApiBaseUrl(raw = process.env.REACT_APP_API_URL) {
  const value = String(raw || DEFAULT_API).trim() || DEFAULT_API;
  return value.endsWith('/') ? value : `${value}/`;
}

export const apiHost = resolveApiBaseUrl().replace(/\/+$/, '');
